import actionCreator from '../../shared/decorators/actionCreator';
import recordForUndo from '../../shared/decorators/recordForUndo';

import {
  BACKGROUND_COLOR_UPDATE_GROUP,
  FILL_COLOR_UPDATE_GROUP,
  REDUX_NAMESPACE,
} from './constants';

const ACTION_CREATORS = {
  @recordForUndo()
  @actionCreator(REDUX_NAMESPACE)
  setAudible(contentId, audible) {
    return {
      contentId,
      audible,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  setCreativeFieldId(contentId, creativeFieldId) {
    return {
      contentId,
      creativeFieldId,
    };
  },

  @recordForUndo()
  @actionCreator(REDUX_NAMESPACE)
  setVisible(contentId, visible) {
    return {
      contentId,
      visible,
    };
  },

  /**
   * Set the fill color of the content (by contentid) - for Shapes, Text
   * @param {String} contentId
   * @param {String} color
   * @returns {{color: {String}, contentId: String}}
   */
  @recordForUndo(FILL_COLOR_UPDATE_GROUP)
  @actionCreator(REDUX_NAMESPACE)
  setFillColor(contentId, color) {
    return {
      color,
      contentId,
    };
  },

  /**
   * Set the background color of the whole creative
   * @param {String } color
   * @returns {{color: String}}
   */
  @recordForUndo(BACKGROUND_COLOR_UPDATE_GROUP)
  @actionCreator(REDUX_NAMESPACE)
  setBackgroundColor(color) {
    return {
      color,
    };
  },
};

export default ACTION_CREATORS;
